import React, { Component } from 'react';
import { Button, } from 'semantic-ui-react'
import Select from 'react-select';
import createBrowserHistory from 'history/createBrowserHistory';
import LargeProjectsNav from './LargeProjectsNav';
import ViewLargeProjects from './ViewLargeProjects'
import {  getSalesPeopleDropDown } from './LargeProjectUtils'
import { firebaseAuth, logComponentLoad} from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';

const history = createBrowserHistory({ forceRefresh: true });

class LargeProjectsHome extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            salesPeopleChoices:[],
            showCommissionButton:false,
            showUnpaidButoon:true,
            syncWithAlogolia: false,
            algoliaUser:''
         }
    }


    componentDidMount(){
        // if(this.props.match.params.filter){
        //     console.log("fillx1 filter is there loading sales people")
        //     getSalesPeople(this.loadSalesPeople);
        // }

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            // console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
        
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("filltx1 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "LargeProjectsHome");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if ( returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("viewAllCommission")) {
            console.log("filltx12 algoliaUser.viewAllCommission is true")
            this.setState({showCommissionButton:true, showUnpaidButoon:true, syncWithAlogolia:true})
        } else {
            console.log("filltx13 algoliaUser.viewAllCommission is FALSE, user not alloed to view commission")
        }
    }


    loadSalesPeople = (salesPeople) => {
        console.log("gts1 ++++++++:loadSalesPeopleDropdown");
       // console.log("gtc15:"+JSON.stringify(salesPeople,null,3));
        if(salesPeople && salesPeople.length > 0){
            //console.log("gtc15 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        }else{
            alert("unable to load customers")
        }
    }

    enterNewCustomer = () => {
        history.push("/dashboard/enterLargeCustomer");
    }

    enterNewProject = () => {
        history.push("/dashboard/enterLargeProject");
    }


    // enterProjectCosts = () => {
    //     history.push("/dashboard/enterProjectCosts");
    // }

    home = () => {
        history.push("/dashboard/largeProjectsHome");
    }

    //this.props.match.params.artist

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }
    
    render() { 

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("sales")
        ? <div>
            <LargeProjectsNav showCommissionButton={this.state.showCommissionButton} 
                    showUnpaidButoon={this.state.showUnpaidButoon}
                    syncWithAlogolia = {this.state.syncWithAlogolia}/>
                <br/>
                {/* {salesPeopleDropDown} */}
                <ViewLargeProjects filter={this.props.match.params.filter} salesPersonId={this.props.salesPersonId}/>
        </div>
        : <h4>loading error a76</h4>

        return ( 
            <div>

                {wholeUI}

                
            </div>
         );
    }
}
 
export default LargeProjectsHome;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/LargeProjectsHome.js